export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ru": {
        "forbidden": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доступ запрещён (403)"])}
      },
      "en": {
        "forbidden": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Forbidden (403)"])}
      }
    }
  })
}
